import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import {
  urlSector,
  urlSectorSecured,
  urlGetAllSectorsSecured,
} from "../../api/urls";

import {
  PAGE_SIZE_10,
  CREATE_SECTOR,
  GET_SECTOR,
  UPDATE_SECTOR,
  DELETE_SECTOR,
  FILTER_SECTOR,
} from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.locationUuid !== undefined)
      filter += "&locationUuid=" + filters.locationUuid;
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.cols !== undefined) filter += "&cols=" + filters.cols;
    if (filters.rows !== undefined) filter += "&rows=" + filters.rows;
    if (filters.active !== undefined) filter += "&active=" + filters.active;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Get Sector by uuid.
 */
export const getSectorByUuid = createAction(GET_SECTOR, (param) =>
  apiGet(urlSectorSecured, param, true)()
);

/**
 * Filter list Sector.
 */
export const filterSector = createAction(FILTER_SECTOR, (filter, param) =>
  apiGet(urlSectorSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Create Sector.
 */
export const createSector = createAction(CREATE_SECTOR, (obj) =>
  apiPost(urlSectorSecured, obj, undefined, true)()
);

/**
 * Update Sector.
 */
export const modifySector = createAction(UPDATE_SECTOR, (obj, param) =>
  apiPut(urlSectorSecured, obj, param, true)()
);

/**
 * Delete Sector by uuid.
 */
export const removeSector = createAction(DELETE_SECTOR, (param) =>
  apiDelete(urlSectorSecured, param, true)()
);

/**
 * Filter list sectors.
 */
export const getAll = createAction("GET_ALL_SECTORS", (filters) =>
  apiGet(
    urlGetAllSectorsSecured + generateFilterQuery(filters),
    undefined,
    false
  )()
);
